<template>
  <div>
    
    <div class="contents">
      <div class="ceping">公司介绍</div>
      <div class="contents mavonEditor md" style="height: auto;display:block; width: 80%;padding: 20px 10% 60px;;" ref="editor" v-html="contents">
      </div>
    </div>
  </div>
</template>

<script>

  import { mavonEditor } from 'mavon-editor'
  import { About_post } from "@/api/gw/aboutus"
  export default {
    components:{
      mavonEditor
    },
    computed: {
    },
    data() {
      return {
        editor: null,
        contents:null
      }
    },
    mounted() {
      About_post().then(res=>{
          this.contents = res.data.content
          this.editor = new E(this.$refs.editor)
          this.editor.customConfig.onchange = (html) => {
            this.editorContent = html
          }
          this.editor.create()
        }).finally(()=>{
        })
    },
    beforeDestroy() {
      this.editor.destroy() // 组件销毁前，销毁编辑器
    },
    methods: {
      
    },
  }
</script>

<style lang="scss" scoped>
  .sucess {
    cursor: pointer;
    width: 600px;
    height: 3rem;
    border-radius: 3rem;
    color: #fff;
    font-size: 16px;
    text-align: center;
    line-height: 3rem;
    background: linear-gradient(to left, #3f7cff, #87abf7);
    margin: 3rem 0%;
    box-shadow: 0 0 8px #ddd;
  }

  .select {
    background: linear-gradient(to left, #3f7cff, #87abf7) !important;

    .ceping01,
    .ceping02,
    .ceping03 {
      color: #fff !important;
    }
  }

  .ceping03 {
    color: #999;
    margin-top: 30px;
    font-size: 15px;
  }

  .ceping02 {
    font-size: 20px;
    margin-top: 30px;
  }

  .ceping01 {
    font-size: 22px;
    font-weight: bold;
    margin-top: 15px;
  }

  .icon {
    width: 64px;
    height: 64px;
  }

  .juti {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;

    .jutis {
      width: 260px;
      height: 300px;
      border-radius: 10px;
      background: #fff;
      box-shadow: 0 0 8px #ddd;
      margin-right: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      cursor: pointer;
    }
  }

  .contents {
    .jianjie {
      color: #666;
      font-size: 16px;
      margin-top: 20px;
    }

    .ceping {
      font-size: 32px;
      font-weight: bold;
      color: #515151;
      margin-top: 30px;
    }

    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/views/aboutus/index.vue